module.exports = __webpack_public_path__ + "img/clock.d800a10e.svg";